<template>
  <div class="flex h-fit flex-col gap-2.5 py-5">
    <LayoutNavbarProductNavigation v-if="isMobile" @menu:close="closeMenu" />

    <!-- Actions -->
    <ul class="flex flex-col md:border-t md:py-2">
      <template v-if="isAuthenticated">
        <li>
          <UiButton
            v-for="(link, index) in links.links"
            :class="
              cn(
                'text-primary min-md:h-10 min-md:text-sm h-auto rounded-none px-5 py-3 text-base hover:bg-neutral-100 [&.active]:font-semibold'
              )
            "
            :key="index"
            variant="list-item"
            :id="link.id"
            :to="link.to"
            @click="handleMenuLinkClick(link.onClick)"
          >
            {{ link.label }}
          </UiButton>
        </li>
      </template>

      <template v-else>
        <li>
          <LayoutUserMenuUserAuthButtons
            class="text-primary h-auto rounded-none px-5 py-3 text-base hover:bg-neutral-100"
            auth-type="signup"
            variant="list-item"
            @close-menu="closeMenu"
          />
        </li>

        <li>
          <LayoutUserMenuUserAuthButtons
            class="text-primary h-auto rounded-none px-5 py-3 text-base hover:bg-neutral-100"
            auth-type="login"
            variant="list-item"
            @close-menu="closeMenu"
          />
        </li>
      </template>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { type HeaderMenuLinks } from "../Navbar.vue"

const { isAuthenticated } = useUser()
const router = useRouterUtils()
const { isMobile } = useDisplay()

const emit = defineEmits(["update:modelValue"])

const props = defineProps<{ links: HeaderMenuLinks; modelValue: boolean }>()

const isUserMenuOpenModel = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
})

const closeMenu = () => (isUserMenuOpenModel.value = false)

function handleMenuLinkClick(clickFn: (() => void) | undefined) {
  if (clickFn) clickFn()
  closeMenu()
}

const isTabActive = (routeName: RoutesNamesList) => {
  try {
    const resolvedRoute = routerResolve({ name: routeName })
    return router.route.value.path.includes(resolvedRoute.path)
  } catch (e) {
    console.error("[UserMenuListItems]: ", e)
    return false
  }
}
</script>
